import React from 'react';

const SvgPt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect
        id="PT_svg__a"
        x={0}
        y={0}
        width="1em"
        height="1em"
        viewBox="0 0 28 20"
        rx={2}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PT_svg__b" fill="#fff">
        <use xlinkHref="#PT_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#PT_svg__a" />
      <path fill="#FF2936" mask="url(#PT_svg__b)" d="M0 0h28v20H0z" />
      <path fill="#128415" mask="url(#PT_svg__b)" d="M0 0h10.667v20H0z" />
      <circle
        stroke="#FAF94F"
        strokeWidth={1.333}
        mask="url(#PT_svg__b)"
        cx={10.667}
        cy={10}
        r={3.333}
      />
      <path
        d="M9.333 8.341c0-.188.144-.341.327-.341h2.013c.18 0 .327.152.327.341v2.327A1.33 1.33 0 0 1 10.667 12c-.737 0-1.334-.59-1.334-1.332V8.341z"
        fill="#FFF"
        mask="url(#PT_svg__b)"
      />
      <path
        d="M10.667 10.667c.368 0 .666-.965.666-1.334a.667.667 0 1 0-1.333 0c0 .369.298 1.334.667 1.334z"
        fill="#1D50B5"
        mask="url(#PT_svg__b)"
      />
    </g>
  </svg>
);

export default SvgPt;
